import { writable } from 'svelte/store';

export const mapBoxInstance = writable({});